<template>
  <div class="processFee column-me">
    <div class="tab-div row-me">
      <div class="tab-item column-me row-center flex-end1" @click="clickTab(0)">
        <div class="tab-title" :class="{'tab-title-active':tabIndex===0}">丸剂</div>
        <div class="tab-line" :class="{'tab-line-active':tabIndex===0}"></div>
      </div>
      <div class="tab-item column-me row-center flex-end1 margin-left30" @click="clickTab(1)">
        <div class="tab-title" :class="{'tab-title-active':tabIndex===1}">膏剂</div>
        <div class="tab-line" :class="{'tab-line-active':tabIndex===1}"></div>
      </div>
      <div class="tab-item column-me row-center flex-end1 margin-left30" @click="clickTab(2)">
        <div class="tab-title" :class="{'tab-title-active':tabIndex===2}">散剂</div>
        <div class="tab-line" :class="{'tab-line-active':tabIndex===2}"></div>
      </div>
      <div class="tab-item column-me row-center flex-end1 margin-left30" @click="clickTab(3)">
        <div class="tab-title" :class="{'tab-title-active':tabIndex===3}">颗粒剂</div>
        <div class="tab-line" :class="{'tab-line-active':tabIndex===3}"></div>
      </div>
      <div class="tab-item column-me row-center flex-end1 margin-left30" @click="clickTab(4)">
        <div class="tab-title" :class="{'tab-title-active':tabIndex===4}">汤剂-代煎</div>
        <div class="tab-line" :class="{'tab-line-active':tabIndex===4}"></div>
      </div>
      <div class="tab-item column-me row-center flex-end1 margin-left30" @click="clickTab(5)">
        <div class="tab-title" :class="{'tab-title-active':tabIndex===5}">中医外治</div>
        <div class="tab-line" :class="{'tab-line-active':tabIndex===5}"></div>
      </div>
    </div>
    <div class="card-div column-me flex1">
      <div class="column-me flex1">
        <button type="button" class="btn-blue width180 height40 margin-bottom20" @click="clickAddFeeType"
                v-if="tabIndex===0&&canOperate">
          <el-icon>
            <plus/>
          </el-icon>
          新增收费类型
        </button>


        <!-- 汤剂代煎 -->
        <div class="row-me row-center padding-top20" v-if="tabIndex===4">
          <div>代煎费：</div>
          <div class="width250">
            <el-input placeholder="请输入" style="width: 100%;" clearable v-model="selectItem.fryingFee"
                      @input="selectItem.fryingFee=$method.checkInput(selectItem.fryingFee,2)"></el-input>
          </div>
          <div class="margin-left10">元/剂</div>
          <div class="btn-blue width140 btn-height40 margin-left100" @click="clickSaveTang" v-if="canOperate">保存</div>
        </div>


        <!-- 其它 -->
        <div v-else>
          <el-table :data="tableData" border header-cell-class-name="table-header-style"
                    cell-class-name="table-cell-style">
            <el-table-column prop="nameType" label="丸剂类型" align="center" v-if="tabIndex===0">
            </el-table-column>
            <el-table-column prop="standard" :label="tabIndex===5?'起做量(贴)':'起做量(kg)'"
                             align="center"></el-table-column>
            <el-table-column prop="first" :label="tabIndex===5?'首重量(贴)':'首重量(kg)'"
                             align="center"></el-table-column>
            <el-table-column label="起始收费(元)" align="center">
              <template #default="scope">
                <div class="column-me padding-left30" style="text-align: left;">
                  <div v-if="scope.row.firstMoney">普装：{{ scope.row.firstMoney }}</div>
                  <div v-if="scope.row.firstMoneyF">分装：{{ scope.row.firstMoneyF }}</div>
                  <div v-if="scope.row.firstMoneyS">散装：{{ scope.row.firstMoneyS }}</div>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="renew" :label="tabIndex===5?'超重量(贴)':'超重量(kg)'"
                             align="center"></el-table-column>
            <el-table-column label="超重收费(元)" align="center">
              <template #default="scope">
                <div class="column-me padding-left30" style="text-align: left;">
                  <div v-if="scope.row.renewMoney">普装：{{ scope.row.renewMoney }}</div>
                  <div v-if="scope.row.renewMoneyF">分装：{{ scope.row.renewMoneyF }}</div>
                  <div v-if="scope.row.renewMoneyS">散装：{{ scope.row.renewMoneyS }}</div>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="成品率(%)" align="center">
              <template #default="scope">
                <div v-if="scope.row.yieldMin!==null&&scope.row.yieldMin!==''">
                  {{ scope.row.yieldMin }} ~ {{ scope.row.yieldMax }}
                </div>
                <div v-else>-</div>
              </template>
            </el-table-column>
            <el-table-column label="操作列" align="center" width="280" v-if="canOperate">
              <template #default="scope">
                <div class="row-me center-all pointer">
                  <div class="btn-blue width100 btn-height40" @click="clickEdit(scope.row)">
                    <el-icon>
                      <edit/>
                    </el-icon>
                    编辑
                  </div>
                  <div class="btn-grey width100 btn-height40 margin-left20"
                       @click="clickDelete(scope.row)" v-if="tabIndex===0">
                    <el-icon>
                      <delete/>
                    </el-icon>
                    删除
                  </div>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>


    <!-- 新增收费类型 -->
    <el-dialog :title="editId!==''?'编辑收费类型':'新增收费类型'" v-model="visible" width="40%" :destroy-on-close="true"
               top="3vh">
      <div class="add-fee-dialog column-me">
        <div class="row-me row-center margin-bottom30" v-if="tabIndex===0">
          <div class="left-title"><span class="red-star">*</span>丸剂类型：</div>
          <div class="width400">
            <el-select placeholder="请选择" style="width: 100%;" filterable clearable
                       v-model="selectItem.nameType">
              <el-option v-for="item in wanTypeArray" :key="item.id" :label="item.name"
                         :value="item.name">
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="row-me row-center">
          <div class="left-title"><span class="red-star">*</span>起做量：</div>
          <div class="width400">
            <el-input placeholder="请输入" style="width: 100%;" clearable v-model="selectItem.standard"
                      @input="selectItem.standard=$method.checkInput(selectItem.standard,3)"></el-input>
          </div>
          <div class="margin-left10">{{ tabIndex === 5 ? '贴' : 'kg' }}</div>
        </div>
        <div class="row-me row-center margin-top30">
          <div class="left-title"><span class="red-star">*</span>首重量：</div>
          <div class="width400">
            <el-input placeholder="请输入" style="width: 100%;" clearable v-model="selectItem.first"
                      @input="selectItem.first=$method.checkInput(selectItem.first,3)"></el-input>
          </div>
          <div class="margin-left10">{{ tabIndex === 5 ? '贴' : 'kg' }}</div>
        </div>
        <div class="row-me row-center margin-top30">
          <div class="left-title"><span class="red-star">*</span>包装类型：</div>
          <el-checkbox v-model="selectItem.puzhuang">普装</el-checkbox>
          <el-checkbox v-model="selectItem.fenzhuang">分装</el-checkbox>
          <el-checkbox v-model="selectItem.sanzhuang">散装</el-checkbox>
        </div>
        <div class="row-me row-center margin-top30" v-if="selectItem.puzhuang">
          <div class="left-title"><span class="red-star">*</span>普装起始收费：</div>
          <div class="width400">
            <el-input placeholder="请输入" style="width: 100%;" clearable v-model="selectItem.firstMoney"
                      @input="selectItem.firstMoney=$method.checkInput(selectItem.firstMoney,2)"></el-input>
          </div>
          <div class="margin-left10">元</div>
        </div>
        <div class="row-me row-center margin-top30" v-if="selectItem.fenzhuang">
          <div class="left-title"><span class="red-star">*</span>分装起始收费：</div>
          <div class="width400">
            <el-input placeholder="请输入" style="width: 100%;" clearable v-model="selectItem.firstMoneyF"
                      @input="selectItem.firstMoneyF=$method.checkInput(selectItem.firstMoneyF,2)"></el-input>
          </div>
          <div class="margin-left10">元</div>
        </div>
        <div class="row-me row-center margin-top30" v-if="selectItem.sanzhuang">
          <div class="left-title"><span class="red-star">*</span>散装起始收费：</div>
          <div class="width400">
            <el-input placeholder="请输入" style="width: 100%;" clearable v-model="selectItem.firstMoneyS"
                      @input="selectItem.firstMoneyS=$method.checkInput(selectItem.firstMoneyS,2)"></el-input>
          </div>
          <div class="margin-left10">元</div>
        </div>
        <!--===================-->
        <div class="row-me row-center margin-top30">
          <div class="left-title"><span class="red-star">*</span>超重量：</div>
          <div class="width400">
            <el-input placeholder="请输入" style="width: 100%;" clearable v-model="selectItem.renew"
                      @input="selectItem.renew=$method.checkInput(selectItem.renew,3)"></el-input>
          </div>
          <div class="margin-left10">{{ tabIndex === 5 ? '贴' : 'kg' }}</div>
        </div>
        <div class="row-me row-center margin-top30" v-if="selectItem.puzhuang">
          <div class="left-title"><span class="red-star">*</span>普装超重收费：</div>
          <div class="width400">
            <el-input placeholder="请输入" style="width: 100%;" clearable v-model="selectItem.renewMoney"
                      @input="selectItem.renewMoney=$method.checkInput(selectItem.renewMoney,2)">
            </el-input>
          </div>
          <div class="margin-left10">元</div>
        </div>
        <div class="row-me row-center margin-top30" v-if="selectItem.fenzhuang">
          <div class="left-title"><span class="red-star">*</span>分装超重收费：</div>
          <div class="width400">
            <el-input placeholder="请输入" style="width: 100%;" clearable v-model="selectItem.renewMoneyF"
                      @input="selectItem.renewMoneyF=$method.checkInput(selectItem.renewMoneyF,2)"></el-input>
          </div>
          <div class="margin-left10">元</div>
        </div>
        <div class="row-me row-center margin-top30" v-if="selectItem.sanzhuang">
          <div class="left-title"><span class="red-star">*</span>散装超重收费：</div>
          <div class="width400">
            <el-input placeholder="请输入" style="width: 100%;" clearable v-model="selectItem.renewMoneyS"
                      @input="selectItem.renewMoneyS=$method.checkInput(selectItem.renewMoneyS,2)"></el-input>
          </div>
          <div class="margin-left10">元</div>
        </div>
        <div class="row-me row-center margin-top30">
          <div class="left-title">成品率：</div>
          <div class="width400 row-me row-center">
            <div class="width150">
              <el-input placeholder="起始值" style="width: 100%;" clearable v-model="selectItem.yieldMin"
                        @input="selectItem.yieldMin=$method.checkInput(selectItem.yieldMin,1)"></el-input>
            </div>
            <div class="margin-left10">%</div>
            <div class="flex1 row-me center-all">—</div>
            <div class="width150">
              <el-input placeholder="结束值" style="width: 100%;" clearable v-model="selectItem.yieldMax"
                        @input="selectItem.yieldMax=$method.checkInput(selectItem.yieldMax,1)"></el-input>
            </div>
          </div>
          <div class="margin-left10">%</div>
        </div>
      </div>
      <div class="row-me flex-end1 margin-top30">
        <div class="btn-blue width140 btn-height40" @click="clickSave">保存</div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      editId: '',
      visible: false,
      tabIndex: 0,
      tableData: [],
      selectItem: {},
      wanTypeArray: [], //丸剂类型
      canOperate: false,
    }
  },
  // html加载完成之前
  created() {
    this.$getMenuOperateAuth(this.$route.path).then(res => {
      this.canOperate = res.data
    })
    this.getData()
    this.wanTypeArray = [{
      id: 0,
      name: '水丸',
    }, {
      id: 1,
      name: '大蜜丸',
    }, {
      id: 2,
      name: '水蜜丸',
    }, {
      id: 3,
      name: '浓缩丸',
    }]
  },
  // html加载完成后执行。
  mounted() {

  },
  // 事件方法执行
  methods: {
    clickTab(index) {
      this.tabIndex = index
      if (index === 4) {
        this.getTangData()
      } else {
        this.getData()
      }
    },
    clickAddFeeType() {
      this.selectItem = {
        puzhuang: true
      }
      this.visible = true
    },
    clickEdit(item) {
      this.editId = item.id
      this.getDetail()
    },
    //删除
    clickDelete(item) {
      this.$confirm("您确定要删除吗？", "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$postFormRequest('/admin/systemConfig/deleteConfig', {
          id: item.id
        }).then((res) => {
          if (res) {
            this.$message.success(res.message)
            this.getData()
          }
        }).catch((error) => {
          console.log(error)
        })
      }).catch(() => {
      });
    },
    //保存汤剂代煎
    clickSaveTang() {
      if (this.$method.isEmpty(this.selectItem.fryingFee)) {
        this.$message.error("请输入代煎费")
        return
      }
      this.$postRequest('/admin/systemConfig/updateConfig', this.selectItem).then((res) => {
        if (res) {
          this.$message.success(res.message)
          this.getTangData()
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    //编辑保存
    clickSave() {
      if (this.tabIndex === 0 && this.$method.isEmpty(this.selectItem.nameType)) {
        this.$message.error("请选择丸剂类型")
        return
      }
      if (this.$method.isEmpty(this.selectItem.standard)) {
        this.$message.error("请输入起做量")
        return
      }
      if (!this.selectItem.puzhuang && !this.selectItem.fenzhuang && !this.selectItem.sanzhuang) {
        this.$message.error("请选择包装类型")
        return
      }
      if (this.selectItem.puzhuang) {
        if (this.$method.isEmpty(this.selectItem.firstMoney)) {
          this.$message.error("请输入普装起始收费")
          return
        }
        if (this.$method.isEmpty(this.selectItem.renewMoney)) {
          this.$message.error("请输入普装超重收费")
          return
        }
      }
      if (this.selectItem.fenzhuang) {
        if (this.$method.isEmpty(this.selectItem.firstMoneyF)) {
          this.$message.error("请输入分装起始收费")
          return
        }
        if (this.$method.isEmpty(this.selectItem.renewMoneyF)) {
          this.$message.error("请输入分装超重收费")
          return
        }
      }
      if (this.selectItem.sanzhuang) {
        if (this.$method.isEmpty(this.selectItem.firstMoneyS)) {
          this.$message.error("请输入散装起始收费")
          return
        }
        if (this.$method.isEmpty(this.selectItem.renewMoneyS)) {
          this.$message.error("请输入散装超重收费")
          return
        }
      }
      if (this.$method.isEmpty(this.selectItem.renew)) {
        this.$message.error("请输入超重量")
        return
      }
      if (this.$method.isEmpty(this.selectItem.yieldMin) || this.$method.isEmpty(this.selectItem.yieldMax)) {
        this.$message.error("请输入成品率")
        return
      }
      if (Number(this.selectItem.yieldMin) > Number(this.selectItem.yieldMax)) {
        this.$message.error("起始值不能大于结束值")
        return
      }
      this.selectItem.configType = 1 //配置类型 0 包材费 1 加工费
      this.$postRequest('/admin/systemConfig/updateConfig', this.selectItem).then((res) => {
        if (res) {
          this.$message.success(res.message)
          this.visible = false
          this.getData()
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    //获取数据
    getData() {
      this.$getRequest('/admin/systemConfig/getConfigList', {
        type: 1,
        nameSearch: this.tabIndex,
      }).then((res) => {
        if (res) {
          this.tableData = res.data
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    //获取汤剂代煎数据
    getTangData() {
      this.$getRequest('/admin/systemConfig/getFryingFeeInfo', {}).then((res) => {
        if (res) {
          this.selectItem = res.data
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    //获取详情数据
    getDetail() {
      this.$getRequest('/admin/systemConfig/getInfo', {
        id: this.editId
      }).then((res) => {
        if (res) {
          this.selectItem = res.data
          this.visible = true
        }
      }).catch((error) => {
        console.log(error)
      })
    },
  },
  // 计算属性
  computed: {},
  // 侦听器
  watch: {},
}
</script>

<style lang="scss" scoped>
.processFee {
  height: 100%;

  .card-div {
    margin: 0 20px 20px 20px;
    background: #FFFFFF;
    box-shadow: 0 0 5px #F3F3F3;
    border-radius: 3px;
    padding: 20px;
  }

  .tab-div {
    background: #FFFFFF;
    margin: 20px;
    padding: 10px 0 0 0;

    .tab-item {
      padding: 0 20px;
      cursor: pointer;

      .tab-title {
        padding-bottom: 10px;

        &-active {
          color: #215AA0;
          font-weight: bold;
        }
      }

      .tab-line {
        width: 100%;
        height: 4px;
        background: #FFFFFF;
        border-radius: 1px;
        margin-top: 10px;

        &-active {
          background: #215AA0;
        }
      }
    }
  }

  .left-title {
    width: 150px;
    text-align: right;
    margin-right: 10px;
  }

  .el-checkbox {
    margin-right: 60px;
  }

  .item-spec {
    width: 220px;
    margin-bottom: 10px;
  }

  .add-fee-dialog {
    height: 75vh;
    overflow: auto;
  }
}
</style>
